module.exports = __webpack_public_path__ + "static/img/c37.4b94af2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c37.jpg
// module id = 113
// module chunks = 10